<ngx-spinner [bdColor]="spinnerConfig.bdColor" [size]="spinnerConfig.size" [color]="spinnerConfig.color" [type]="spinnerConfig.type" [fullScreen]="true">
    <p style="color: white"> Carregando... </p>
</ngx-spinner>
<router-outlet></router-outlet>
